import { useState } from 'react';
import Papa from 'papaparse';
import { db } from '../firebase';
import {
  collection, getDocs, doc, setDoc, writeBatch
} from 'firebase/firestore';

// ─── Google Sheets URLs ────────────────────────────────────────────
const URLS = {
  home_banners:        'https://docs.google.com/spreadsheets/d/e/2PACX-1vTUj5foH-u4ZUk9HUZ2bffWJdm3YEPqJ6SIlr3s2eI6nSnwimJBK78jHHBxTRXEYlAs1rlU5ExBfLdQ/pub?output=csv',
  home_intro:          'https://docs.google.com/spreadsheets/d/e/2PACX-1vRqqeeHCwu1EU1BizXNXDX4uEAs5czECJ7I7LhhsluEVebWo4UIDVXEKSUyGy3aqHEwc5jbBmTIqVFC/pub?output=csv',
  home_why_choose:     'https://docs.google.com/spreadsheets/d/e/2PACX-1vS-45hkx02bp2YQjdv7V4sV0y4XpeKiFvw7er9NoDnRfcp2tPaZkYuUebTWe6WKVtXDanrufk0Y0aZq/pub?output=csv',
  home_info_cards:     'https://docs.google.com/spreadsheets/d/e/2PACX-1vRBubwUhmxAAoX9iud8Du7rTUM-sRQOcKgzbd3AYMIRbQM6PlhpJqi8g5RbVpdUbRInCPIO2AbtYV7U/pub?output=csv',
  home_vanity_images:  'https://docs.google.com/spreadsheets/d/e/2PACX-1vSwlgViLWKl1F4t-SMq-Vft4Jo9XyVyWW2YCUfhqBRzZJ6qPulVY6_0dFuataZmHjTLUVIJy7ynNlyB/pub?output=csv',
  faqs:                'https://docs.google.com/spreadsheets/d/e/2PACX-1vTYxvEpN_UuWQBPgQ_8n9Wdro-NRZsWDNzpcbPyK7YJgIpx-AysW1zCBDxTqw_EXjQWHfXvFCQ6QY-H/pub?output=csv',
  testimonials:        'https://docs.google.com/spreadsheets/d/e/2PACX-1vSWcrqK0QPfJYKPhix7EyTv8NaXeEXk_UAw0ndbp7tHyE5rFgOltdbO0WEDRnXeTUXnMOunvScR64UD/pub?output=csv',
  testimonials_course: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRwhbjqy7KMpMJpK9Ghu8XFovTqxU5yFEMGk2PbihBlJ6eANv237rxihhRA_odGPLezKGAlUSBTuzsR/pub?output=csv',
  ourwork_photos:      'https://docs.google.com/spreadsheets/d/e/2PACX-1vRiTSjioVxCxeED015TiJmgrijnB2ltjNlUx0Q1FUSFCs582JjXYQiJpv38Q44Egg9QBtoJZijlxsCS/pub?output=csv',
  ourwork_videos:      'https://docs.google.com/spreadsheets/d/e/2PACX-1vT5k_4-bFNZW8f4mOmgO9CbI0-6ZfikOe8F1pQVKIglED67x20slDoxP0FIdSpmbwZRylIGbn2hAISE/pub?output=csv',
  about_paragraph:     'https://docs.google.com/spreadsheets/d/e/2PACX-1vQeRBBlJ5gASY99SCGjdycvWEsxb7oObaLEjrK3HXWtKp3RKvLOTN5GDuTIdJTrD_oWRUQreeej2bFn/pub?output=csv',
  about_mv:            'https://docs.google.com/spreadsheets/d/e/2PACX-1vQTWcCHIT9jDkvkDPrkzMK1psb051FigTWMYrQ4Ny1YwERO6-g_2fz09cMb4feHxsV-kzopgA13zSsm/pub?output=csv',
  milestones:          'https://docs.google.com/spreadsheets/d/e/2PACX-1vTAHAC7fXb_jpjqi04YmFHJNHK_EpT2xYq76a3S-MJEOqLJAk09QfSfKj0ljl-jqicpgPeATpDTw2qP/pub?output=csv',
  founder:             'https://docs.google.com/spreadsheets/d/e/2PACX-1vQO5B0Y23PQeT8tSUpEPJEvL3EwuA5kVY73j0ihYbsZXdGgSi0s3LRSDQSAmfWLDHBeRX6290rdD6Ei/pub?output=csv',
  bridal_images:       'https://docs.google.com/spreadsheets/d/e/2PACX-1vTpTmQ0Tj6hR81OcY8VB3RV2O3eV8fNWea1xZGBBdssnZEQgRjSiuqaGElqVyEGAX5z1JkAgytTQE_b/pub?output=csv',
  party_images:        'https://docs.google.com/spreadsheets/d/e/2PACX-1vT7BnBV6Qvk7C8SD27ry2EOXNf3Xe8IaKB6hq-ttjq_OrSF2MMgx-FMfi7NAQ3yg8_IJO8Evc7KeXB_/pub?output=csv',
  editorial_images:    'https://docs.google.com/spreadsheets/d/e/2PACX-1vSc-wBJ6N3robC2jgSC3F1Ut6lFsgwQdHM1hGy4Trc-OO6POjHExLoaVNhXUqdThNev41NdqBJagI0j/pub?output=csv',
  groom_images:        'https://docs.google.com/spreadsheets/d/e/2PACX-1vSuMRYoJUD5YlSq58YzsssI4sggVtexyZyFr4MZUPkdqL0tk1UIlBrqileMy8fi9kaGXMobohS-BmyX/pub?output=csv',
  course_images:       'https://docs.google.com/spreadsheets/d/e/2PACX-1vS3HuHlt1e0zT5504A3Cac2gF3P_jA_a1tpKhqT5hJlpNZ4GK-SzK8e_C62LstBjfhMpmR7eRZc3xSB/pub?output=csv',
  tutorial_images:     'https://docs.google.com/spreadsheets/d/e/2PACX-1vRPNHn8pFvLWO5St7_J9ZbSNQp0XCJex6NSzHaCSwQpVRVa--NaSIYcuKAWX8KcVLmSXlFnqSrb1yjc/pub?output=csv',
  bride_passcodes:     'https://docs.google.com/spreadsheets/d/e/2PACX-1vShHbysB9-xPrvbPSKhEimAaxbmuooH-2X40DEt_K0aRh5hHJSO1PVd62F9-XXOOiEbYNUQfZArn8zS/pub?output=csv',
  instagram_posts:     'https://docs.google.com/spreadsheets/d/e/2PACX-1vSNEFvvz32cxM3VnYjQuEDEB8cCX-u1VWMr6vFvEleiI92prMmrqEZoeUJCFrTE5N_h0OL0pUq23ZYr/pub?output=csv',
};

// ─── Helpers ───────────────────────────────────────────────────────
const fetchCSV = (url) =>
  fetch(url).then(r => r.text());

const parseCSV = (text, opts = {}) =>
  Papa.parse(text.trim(), { header: true, skipEmptyLines: true, ...opts }).data;

const clearAndBatchWrite = async (colName, items) => {
  const colRef = collection(db, colName);
  const existing = await getDocs(colRef);
  for (let i = 0; i < existing.docs.length; i += 400) {
    const batch = writeBatch(db);
    existing.docs.slice(i, i + 400).forEach(d => batch.delete(d.ref));
    await batch.commit();
  }
  for (let i = 0; i < items.length; i += 400) {
    const batch = writeBatch(db);
    items.slice(i, i + 400).forEach((item, idx) => {
      batch.set(doc(colRef, `item_${String(i + idx).padStart(4, '0')}`), item);
    });
    await batch.commit();
  }
};

// ─── Migration Functions ───────────────────────────────────────────
const migrations = {
  home_banners: async () => {
    const rows = parseCSV(await fetchCSV(URLS.home_banners));
    const items = rows.filter(r => r.Image && r.Link)
      .map((r, i) => ({ Image: r.Image, Link: r.Link, order: i }));
    await clearAndBatchWrite('home_banners', items);
    return items.length;
  },

  home_intro: async () => {
    const text = await fetchCSV(URLS.home_intro);
    const lines = text.split('\n').map(l => l.trim()).filter(Boolean);
    await setDoc(doc(db, 'home_intro', 'content'), {
      heading: lines[0] || '',
      paragraph: lines[1] || '',
    });
    return 1;
  },

  home_why_choose: async () => {
    const text = await fetchCSV(URLS.home_why_choose);
    const lines = text.split('\n').map(l => l.trim()).filter(Boolean);
    await setDoc(doc(db, 'home_why_choose', 'content'), {
      image: lines[0] || '',
      points: lines.slice(1),
    });
    return 1;
  },

  home_info_cards: async () => {
    const text = await fetchCSV(URLS.home_info_cards);
    const rows = text.trim().split('\n').map(row => row.split(','));
    const items = rows
      .map(([img, title, desc, link], i) => ({ img: img?.trim(), title: title?.trim(), desc: desc?.trim(), link: link?.trim(), order: i }))
      .filter(r => r.img);
    await clearAndBatchWrite('home_info_cards', items);
    return items.length;
  },

  home_vanity_images: async () => {
    const text = await fetchCSV(URLS.home_vanity_images);
    const items = text.trim().split('\n').map(l => l.trim()).filter(Boolean)
      .map((url, i) => ({ url, order: i }));
    await clearAndBatchWrite('home_vanity_images', items);
    return items.length;
  },

  faqs: async () => {
    const text = await fetchCSV(URLS.faqs);
    const rows = text.trim().split('\n').slice(1);
    const items = rows.map((row, i) => {
      const [question, ...rest] = row.split(',');
      return { question: question?.trim(), answer: rest.join(',').trim(), order: i };
    }).filter(r => r.question);
    await clearAndBatchWrite('faqs', items);
    return items.length;
  },

  testimonials: async () => {
    const text = await fetchCSV(URLS.testimonials);
    const rows = text.trim().split('\n').slice(1);
    const items = rows.map((row, i) => {
      const [image, name, service, ...feedbackArr] = row.split(',');
      return { image: image?.trim(), name: name?.trim(), service: service?.trim(), feedback: feedbackArr.join(',').trim(), order: i };
    }).filter(r => r.image);
    await clearAndBatchWrite('testimonials', items);
    return items.length;
  },

  testimonials_course: async () => {
    const text = await fetchCSV(URLS.testimonials_course);
    const rows = text.trim().split('\n').slice(1);
    const items = rows.map((row, i) => {
      const [image, name, service, ...feedbackArr] = row.split(',');
      return { image: image?.trim(), name: name?.trim(), service: service?.trim(), feedback: feedbackArr.join(',').trim(), order: i };
    }).filter(r => r.image);
    await clearAndBatchWrite('testimonials_course', items);
    return items.length;
  },

  ourwork_photos: async () => {
    const rows = parseCSV(await fetchCSV(URLS.ourwork_photos));
    const items = rows.filter(r => r.Image && r.Title)
      .map((r, i) => ({ Image: r.Image, Title: r.Title, order: i }));
    await clearAndBatchWrite('ourwork_photos', items);
    return items.length;
  },

  ourwork_videos: async () => {
    const rows = parseCSV(await fetchCSV(URLS.ourwork_videos));
    const items = rows.filter(r => r.Link)
      .map((r, i) => ({ Link: r.Link, order: i }));
    await clearAndBatchWrite('ourwork_videos', items);
    return items.length;
  },

  about_content: async () => {
    const rows = parseCSV(await fetchCSV(URLS.about_paragraph));
    await setDoc(doc(db, 'about_content', 'main'), { Paragraph: rows[0]?.Paragraph || '' });
    return 1;
  },

  about_mission_vision: async () => {
    const rows = parseCSV(await fetchCSV(URLS.about_mv));
    const colRef = collection(db, 'about_mission_vision');
    const existing = await getDocs(colRef);
    const delBatch = writeBatch(db);
    existing.docs.forEach(d => delBatch.delete(d.ref));
    if (existing.docs.length > 0) await delBatch.commit();
    const batch = writeBatch(db);
    rows.filter(r => r.Title && r.Description).forEach(r => {
      batch.set(doc(colRef, r.Title), { Title: r.Title, Description: r.Description });
    });
    await batch.commit();
    return rows.length;
  },

  milestones: async () => {
    const rows = parseCSV(await fetchCSV(URLS.milestones));
    const items = rows.filter(r => r.Number && r.Title)
      .map((r, i) => ({ Number: r.Number, Title: r.Title, order: i }));
    await clearAndBatchWrite('milestones', items);
    return items.length;
  },

  founder: async () => {
    const rows = parseCSV(await fetchCSV(URLS.founder));
    if (rows[0]) {
      await setDoc(doc(db, 'founder', 'content'), {
        Image:      rows[0].Image      || '',
        Name:       rows[0].Name       || '',
        Subheading: rows[0].Subheading || '',
        Paragraph:  rows[0].Paragraph  || '',
      });
    }
    return 1;
  },

  bridal_images:    async () => { const rows = parseCSV(await fetchCSV(URLS.bridal_images));    const items = rows.filter(r => r.Image).map((r, i) => ({ image: r.Image, order: i })); await clearAndBatchWrite('bridal_images', items);    return items.length; },
  party_images:     async () => { const rows = parseCSV(await fetchCSV(URLS.party_images));     const items = rows.filter(r => r.Image).map((r, i) => ({ image: r.Image, order: i })); await clearAndBatchWrite('party_images', items);     return items.length; },
  editorial_images: async () => { const rows = parseCSV(await fetchCSV(URLS.editorial_images)); const items = rows.filter(r => r.Image).map((r, i) => ({ image: r.Image, order: i })); await clearAndBatchWrite('editorial_images', items); return items.length; },
  groom_images:     async () => { const rows = parseCSV(await fetchCSV(URLS.groom_images));     const items = rows.filter(r => r.Image).map((r, i) => ({ image: r.Image, order: i })); await clearAndBatchWrite('groom_images', items);     return items.length; },
  course_images:    async () => { const rows = parseCSV(await fetchCSV(URLS.course_images));    const items = rows.filter(r => r.Image).map((r, i) => ({ image: r.Image, order: i })); await clearAndBatchWrite('course_images', items);    return items.length; },
  tutorial_images:  async () => { const rows = parseCSV(await fetchCSV(URLS.tutorial_images));  const items = rows.filter(r => r.Link && r.Title).map((r, i) => ({ title: r.Title.trim(), link: r.Link.trim(), order: i })); await clearAndBatchWrite('tutorial_videos', items);  return items.length; },

  bride_passcodes: async () => {
    const rows = parseCSV(await fetchCSV(URLS.bride_passcodes));
    const items = rows.filter(r => r.Passcode)
      .map((r, i) => ({ passcode: r.Passcode.trim(), order: i }));
    await clearAndBatchWrite('bride_passcodes', items);
    return items.length;
  },

  instagram_posts: async () => {
    const rows = parseCSV(await fetchCSV(URLS.instagram_posts));
    const items = rows.filter(r => r.Image && r.Title && r.Link)
      .map((r, i) => ({ Image: r.Image, Title: r.Title, Link: r.Link, order: i }));
    await clearAndBatchWrite('instagram_posts', items);
    return items.length;
  },
};

const COLLECTION_LABELS = {
  home_banners:        'Home Banners',
  home_intro:          'Home Intro Text',
  home_why_choose:     'Why Choose Us',
  home_info_cards:     'Home Info Cards',
  home_vanity_images:  'Vanity Images (scroll row)',
  faqs:                'FAQs',
  testimonials:        'Testimonials (main)',
  testimonials_course: 'Testimonials (course page)',
  ourwork_photos:      'Our Work — Photos',
  ourwork_videos:      'Our Work — Videos',
  about_content:       'About Paragraph',
  about_mission_vision:'Mission & Vision',
  milestones:          'Milestones',
  founder:             'Founder Info',
  bridal_images:       'Bridal Gallery',
  party_images:        'Party Gallery',
  editorial_images:    'Editorial Gallery',
  groom_images:        'Groom Gallery',
  course_images:       'Course Gallery',
  tutorial_images:     'Tutorial Videos',
  bride_passcodes:     'Bride Passcodes',
  instagram_posts:     'Instagram Highlights',
};

const KEYS = Object.keys(COLLECTION_LABELS);

export default function MigrateData() {
  const [statuses, setStatuses] = useState({});

  const setStatus = (key, val) =>
    setStatuses(s => ({ ...s, [key]: val }));

  const run = async (key) => {
    setStatus(key, { state: 'running' });
    try {
      const count = await migrations[key]();
      setStatus(key, { state: 'done', count });
    } catch (err) {
      setStatus(key, { state: 'error', msg: err.message });
    }
  };

  const runAll = () => KEYS.forEach(k => run(k));

  const allDone = KEYS.every(k => statuses[k]?.state === 'done');
  const anyRunning = KEYS.some(k => statuses[k]?.state === 'running');

  return (
    <div style={{ maxWidth: 720, margin: '80px auto', padding: '0 20px', fontFamily: 'Red Hat Display, sans-serif' }}>
      <h1 style={{ color: '#3e1c00' }}>Firebase Migration Tool</h1>
      <p style={{ color: '#555', marginBottom: 24 }}>
        Run this once to copy all Google Sheets data into Firestore.
        Each collection can be re-migrated independently to refresh data.
      </p>

      <button
        onClick={runAll}
        disabled={anyRunning}
        style={{ background: '#3e1c00', color: '#eae1d8', border: 'none', padding: '12px 28px', borderRadius: 8, fontSize: 16, cursor: anyRunning ? 'not-allowed' : 'pointer', marginBottom: 32 }}
      >
        {anyRunning ? 'Migrating…' : allDone ? '✓ All Done — Re-run All' : 'Migrate All Collections'}
      </button>

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#eae1d8' }}>
            <th style={th}>Collection</th>
            <th style={th}>Status</th>
            <th style={th}>Action</th>
          </tr>
        </thead>
        <tbody>
          {KEYS.map(key => {
            const s = statuses[key];
            return (
              <tr key={key} style={{ borderBottom: '1px solid #e0d5cb' }}>
                <td style={td}>{COLLECTION_LABELS[key]}</td>
                <td style={td}>
                  {!s && <span style={{ color: '#aaa' }}>idle</span>}
                  {s?.state === 'running' && <span style={{ color: '#b87333' }}>⏳ running…</span>}
                  {s?.state === 'done'    && <span style={{ color: '#2e7d32' }}>✓ {s.count} items</span>}
                  {s?.state === 'error'   && <span style={{ color: '#c62828', fontSize: 12 }}>✗ {s.msg}</span>}
                </td>
                <td style={td}>
                  <button
                    onClick={() => run(key)}
                    disabled={s?.state === 'running'}
                    style={{ background: 'transparent', border: '1px solid #3e1c00', color: '#3e1c00', padding: '4px 12px', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}
                  >
                    {s?.state === 'done' ? 'Re-run' : 'Migrate'}
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

const th = { padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#3e1c00' };
const td = { padding: '10px 12px', color: '#333' };
